import { rawPalette } from "../../styles/theme.css";

export interface AILoadingIndicatorIconProps {
    stroke?: string;
    className?: string;
}

export function AILoadingIndicatorIcon({
    // Raw, not a token: `stroke` is an SVG attribute, where var() does not apply.
    stroke = rawPalette.base.brandBlue[900],
    className,
}: AILoadingIndicatorIconProps) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clip-path="url(#clip0_2492_4325)">
                <path
                    d="M2.33325 9.00004L8.66659 4.33337L10.3333 13L2.33325 9.00004Z"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.3333 13.0001L15.6266 6.66676L8.66658 4.33343L3.01992 1.72009L2.33325 9.00009L4.35992 15.6068L10.3333 13.0001Z"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.3333 13L13.2666 14.6333"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M4.21994 15.4801C4.25239 15.5361 4.30078 15.5812 4.35894 15.6097C4.41711 15.6382 4.48243 15.6488 4.54661 15.6401L13.1133 14.6667C13.1781 14.6579 13.239 14.6306 13.2886 14.588C13.3383 14.5454 13.3746 14.4894 13.3933 14.4267L15.6199 6.80673C15.6341 6.75551 15.636 6.70169 15.6256 6.6496C15.6152 6.5975 15.5927 6.54857 15.5599 6.50673L10.7866 0.486725C10.7501 0.440256 10.7017 0.404555 10.6465 0.383423C10.5913 0.362292 10.5315 0.356521 10.4733 0.366725L3.19327 1.63339C3.13466 1.64203 3.07951 1.66645 3.03371 1.70403C2.98791 1.74161 2.95319 1.79093 2.93327 1.84673L0.386607 8.85339C0.366727 8.89739 0.356445 8.94511 0.356445 8.99339C0.356445 9.04167 0.366727 9.0894 0.386607 9.13339L4.21994 15.4801Z"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M8.6665 4.33334L10.6398 0.380005"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M0.366699 9H2.33337"
                    stroke={stroke}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2492_4325">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
